import { StyleSheet } from "react-native";
import { ThemeView } from '@/components/Theme';

const CardContent = (props) => {
        
    const {
        children = null,
        style = null,
        light = null,
        dark = null,
    } = props;

    return (
        <ThemeView light={light} dark={dark} style={[styles.container, style]}>
            {children}
        </ThemeView>
    );
}

const styles = StyleSheet.create({
    container: {
        padding: 15
    }
});

export default CardContent;